import Container from './Container';
import LiveRtpCarousel from './LiveRtpCarousel';

type Props = { type: RtpType; rtp: RtpType };

const TopGamesCarousel: FC<Props> = ({ type, rtp }) => {
  const show = type === rtp;
  return (
    <Container show={show}>
      <LiveRtpCarousel type={type} />
    </Container>
  );
};

export default TopGamesCarousel;
